import { SelectItem } from 'vet-bones/utils/select';

export type DataSourceTable = {
  name: string;
  catalog?: string;
  schema?: string;
};

export type DataSourceTableSelectItem = SelectItem & DataSourceTable;

/**
 * Creates a unique composite key for a DataSourceTable from its catalog, schema, and name.
 * Used for identity checks instead of comparing by name alone, which fails when
 * the same table name exists in multiple schemas/catalogs.
 */
export const getDataSourceTableKey = (table: DataSourceTable): string =>
  [table.catalog, table.schema, table.name].filter(Boolean).join('.');
